// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var H2 = function H2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.5 4.75A.75.75 0 0 0 .75 4a.75.75 0 0 0-.75.75v10.5c0 .416.334.75.75.75s.75-.334.75-.75V10.5h7v4.75c0 .416.334.75.75.75s.75-.334.75-.75V4.75A.75.75 0 0 0 9.25 4a.75.75 0 0 0-.75.75V9h-7zm12.416 1.275a2.18 2.18 0 0 1 1.418-.525h.288a2.38 2.38 0 0 1 1.616 4.131L11.74 14.7a.75.75 0 0 0 .509 1.303h7c.416 0 .75-.334.75-.75a.75.75 0 0 0-.75-.75h-5.081l4.084-3.772A3.881 3.881 0 0 0 15.62 4h-.288a3.7 3.7 0 0 0-2.393.884l-.929.794a.748.748 0 1 0 .975 1.138l.928-.794z"
  }));
};
